import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求标签组列表
export const getlabelChildList = params => {
    return get("/admin/tag", params);
};

// 修改信息
export const editlabelChild = params => {
    return put(`/admin/tag/${params.id}`, params);
};

// 添加标签组
export const addlabelChild = params => {
    return post("/admin/tag", params);
};

// 删除标签组
export const deletelabelChild = params => {
    return del(`/admin/tag/${params}`);
};

// 子标签下拉
export const labelChildList = params => {
    return get("/admin/tagSele", params);
};

// 子标签下拉*
export const tagSeleList = params => {
    return get("/admin/tag/list", params);
};

// 话术子标签下拉*
export const huaShuTagSeleList = params => {
    return get("/admin/tag/script", params);
};


// WEBPACK FOOTER //
// ./src/api/labelChild.js